import * as z from "zod";

export const InventoryPurchaseOrdersFlatTeamSettingsSchema = z.object({
  "ims/purchaseOrderDefaultLocationId": z.string().nullish(),
  "ims/purchaseOrderDefaultCcEmails": z.array(z.string()).nullish(),
  "ims/purchaseOrderRecommendationUrgencies": z.array(z.string()).nullish(),
});
